import {
    CREATE_GLOSSARY_CATEGORY_OPERATION,
    CREATE_GLOSSARY_TERM_OPERATION,
    DELETE_GLOSSARY_CATEGORY_OPERATION,
    DELETE_GLOSSARY_TERM_OPERATION,
    GET_GLOSSARY_OPERATION,
    UPDATE_GLOSSARY_CATEGORY_NAME_OPERATION,
    UPDATE_GLOSSARY_TERM_OPERATION
} from 'app/store/__generated__/operations';
import {
    LOAD_GLOSSARY,
    CREATE_CATEGORY,
    DELETE_CATEGORY,
    RENAME_CATEGORY,
    CREATE_GLOSSARY_TERM,
    UPDATE_GLOSSARY_TERM,
    DELETE_GLOSSARY_TERM
} from './types.js';

export const doLoadGlossary = () => ({
    type: LOAD_GLOSSARY,
    api: GET_GLOSSARY_OPERATION
});

export const doCreateCategory = ({ categoryName }) => ({
    type: CREATE_CATEGORY,
    api: CREATE_GLOSSARY_CATEGORY_OPERATION,
    params: { categoryName }
});

export const doDeleteCategory = ({ categoryName }) => ({
    type: DELETE_CATEGORY,
    api: DELETE_GLOSSARY_CATEGORY_OPERATION,
    params: { categoryName }
});

export const doRenameCategory = ({ categoryName, newCategoryName }) => ({
    type: RENAME_CATEGORY,
    api: UPDATE_GLOSSARY_CATEGORY_NAME_OPERATION,
    params: { categoryName, newCategoryName }
});

export const doCreateGlossaryTerm = ({ categoryName, name, description }) => ({
    type: CREATE_GLOSSARY_TERM,
    api: CREATE_GLOSSARY_TERM_OPERATION,
    params: { categoryName, name, description }
});

export const doUpdateGlossaryTerm = ({ categoryName, name, description }) => ({
    type: UPDATE_GLOSSARY_TERM,
    api: UPDATE_GLOSSARY_TERM_OPERATION,
    params: { categoryName, name, description }
});

export const doDeleteGlossaryTerm = ({ name }) => ({
    type: DELETE_GLOSSARY_TERM,
    api: DELETE_GLOSSARY_TERM_OPERATION,
    params: { name }
});
